<template>
  <div class="campaign-insights-number">

    <div class="mt-10 mb-10 card">
      <div class="float-left insights-title mb-4">
        <h2>Campaign Insights</h2>
      </div>

      <div class="float-right">
        <!-- desktop version -->
        <ul class="insights-filter-desktop-version list-none text-right">
          <li class="float-right ml-4">
            <vs-button id="insights-filter-button" class="shadow-none speakol-table-filter-button" @click="filter">
              {{ $t('Filter') }}
            </vs-button>
          </li>
          <li class="float-right w-64">
            <speakol-date-range-picker id="insights-date-range-picker-input" :minimumDate="minDate" :ignoreDefault="true" v-model="filters.dateRange"
              :placeholder="$t('Filter by date')"></speakol-date-range-picker>
          </li>
          <li class="float-right w-64 mr-3">
            <treeselect
              id="insights-events-list"
              :disabled="isConversionsFilterDisabled"
              :options="pixelEvents"
              v-model="filters.pixelEvent"
              placeholder="Conversions">
            </treeselect>
          </li>
          <li class="float-right w-64 mr-3">
            <treeselect id="insights-all-adsets-list" :options="campaign.adsets.map(i => ({id: i.id, label: i.name}))" v-model="filters.adset"
              placeholder="All Adsets"></treeselect>
          </li>
        </ul>
        <!-- desktop version -->

        <!-- mobile version -->
        <ul class="insights-filter-mobile-version list-none text-right">
          <li class="inline-block float-right w-full my-4">
            <speakol-date-range-picker id="insights-date-range-picker-input" :minimumDate="minDate" :ignoreDefault="true" v-model="filters.dateRange"
              :placeholder="$t('Filter by date')"></speakol-date-range-picker>
          </li>
          <li class="inline-block float-right w-full mb-4">
            <treeselect id="insights-events-list" :options="pixelEvents" v-model="filters.pixelEvent" placeholder="Conversions"></treeselect>
          </li>
          <li class="inline-block float-right w-full">
            <treeselect id="insights-all-adsets-list" :options="campaign.adsets.map(i => ({id: i.id, label: i.name}))" v-model="filters.adset"
              placeholder="All Adsets"></treeselect>
          </li>
          <li class="inline-block float-right w-full mt-4 speakol-table-filter-button-parent">
            <vs-button id="insights-filter-button" class="shadow-none speakol-table-filter-button" @click="filter">
              {{ $t('Filter') }}
            </vs-button>
          </li>
        </ul>
        <!-- mobile version -->
      </div>

      <CardsInsights ref="CardsInsights" class="w-full" :filters="filters" />

      <ChartInsights ref="ChartInsights" class="mt-10 w-full" :filters="filters" />


    </div>

    <!-- <div class="card mb-10">
      <div class="md:flex chart-title">
        <h3>Performance</h3>
        <span>The metrics will be reflected on the two sections below.</span>
      </div>

      <div class="flex chart-map flex-wrap">
        <div class="w-full mb-2 md:mb-10">
          <div class="w-full md:w-1/2 flex flex-wrap">
            <SpeakolChartFilter v-for="filter in chartFilters" :text="filter.text"
              class="w-34 mr-10 mb-8 md:mr-24 md:mb-0" :color="filter.color" :ref="filter.value" :value="filter.value"
              :key="filter.value" :clickable="!isFilterSelected(filter.value)" v-on:toggled="updateActiveFilter" />
          </div>
        </div>

        <div class="w-full md:w-1/2 mb-8 md:mb:0">

          <InsightsMap id="map" ref="map" :filters="chartFilters" :width="mapWidth" :height="mapHeight"
            :geoInsights="geoInsights">
            <template v-slot:empty-country-tooltip>
              <ChartErrorMessage />
            </template>
          </InsightsMap>

        </div>

        <div class="device-split md:w-1/2 w-full">
          <div class="device-split-desc">
            <span class="device-chart-title" style="color: #2c2c2c;">Device Split</span>
            <h6 class="mt-3 mb-47 device-chart-desc">This new feature provides information starting from the <b>Jan 5,
                2021</b> onwards.</h6>
          </div>
          <deviceChart ref="device-chart" :chartData="deviceChartData" :key="deviceChartKey" :accountHasCampaigns="true"
            :displayColumn="displayColumn" />
        </div>
      </div>
    </div> -->

    <div class="">
      <TablesInsights ref="TablesInsights" :filters="filters" />
    </div>

  </div>
</template>

<script>
import ChartInsights from '@/views/campaigns/insights/components/_content_partials/ChartInsights.vue'
import CardsInsights from '@/views/campaigns/insights/components/_content_partials/CardsInsights.vue'
import TablesInsights from '@/views/campaigns/insights/components/_content_partials/TablesInsights.vue'
import deviceChart from '@/views/home/components/device-chart.vue'
import InsightsMap from './InsightsMap'
import ChartErrorMessage from '@/views/home/components/empty-state'
import {flatMap} from 'lodash'

// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {
  mapGetters
} from 'vuex'

export default {
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  components: {
    Treeselect,
    ChartInsights,
    CardsInsights,
    TablesInsights,
    deviceChart,
    InsightsMap,
    ChartErrorMessage
  },
  computed: {
    ...mapGetters({
      pixelEvents: 'campaign/pixelEvents'
    }),

    isConversionsFilterDisabled () {
      return this.campaign.objective_id === this.$constants.CAMPAIGN_OBJECTIVES_IDS.LEAD_FORM
    }
  },
  async mounted () {
    this.getDeviceAnalytics()
    this.$nextTick(() => {
      const filterQuery = this.filterQueryBuilder()
      this.getMapGeoAnalytics(filterQuery)
      // this.mapWidth = document.getElementById('map').offsetWidth - 40
      // this.mapHeight = this.mapWidth / 1.7
    }, 0)
  },
  data () {
    return {
      // Selected Filter
      selectedFilter: 'impressions',

      // map //
      mapWidth: 0,
      mapHeight: 0,
      geoInsights: [],

      // device chart //
      deviceChartData: [],
      displayColumn: 'impressions',
      deviceChartKey: 'impressions',
      filters: {
        dateRange: {
          startDate: this.calculateStartDate(),
          endDate: new Date()
        },
        adset: null,
        pixelEvent: this.campaign.objective_id === this.$constants.CAMPAIGN_OBJECTIVES_IDS.LEAD_FORM ? this.$constants.ANALYTICS_EVENTS_NAMES.LEADS : null
      },
      minDate: this.calculateMinDate(),
      chartFilters:[
        {
          color: '#0092D7',
          text: 'Impressions',
          value: 'impressions'
        },
        {
          color: '#00336E',
          text: 'Clicks',
          value: 'clicks'
        },
        {
          color: '#6EC8BA',
          text: 'Spent',
          value: 'spent'
        }
      ]
    }
  },
  methods: {
    async filter () {
      this.filters.dateRange = this.formatFilterationDate(this.filters.dateRange)
      await this.$refs.CardsInsights.fetchInsights()
      await this.$refs.ChartInsights.fetchChartData()
      await this.$refs.TablesInsights.fetchData()
      await this.getDeviceAnalytics()
      const filterQuery = this.filterQueryBuilder()
      await this.getMapGeoAnalytics(filterQuery)
    },
    filterQueryBuilder () {
      return {
        'type': 'ads',
        'from-date': this.filters.dateRange.startDate,
        'to-date': this.filters.dateRange.endDate,
        'ids': this.filters.adset ? this.getAdsetsAdsIds(this.filters.adset) : this.getAdsetsAdsIds(this.campaign
          .adsets)
      }
    },
    getAdsetsAdsIds (adsets) {
      if (typeof adsets === 'number') {
        for (let i = 0; i < this.campaign.adsets.length; i++) {
          if (adsets === this.campaign.adsets[i].id) {
            return flatMap(this.campaign.adsets[i].ads, 'id')
          }
        }
      }
      return flatMap(flatMap(adsets, 'ads'), 'id')
    },
    formatFilterationDate (dateRange) {
      return {
        startDate: this.$moment(dateRange.startDate).format('YYYY-MM-DD'),
        endDate: this.$moment(dateRange.endDate).format('YYYY-MM-DD')
      }
    },
    subtractDays (date, days = 0) {
      return new Date(date.setDate(date.getDate() - days)).toISOString().split('T')[0]
    },
    calculateStartDate () {
      const accountCreatedAt = new this.$moment(this.$store.getters['authentication/activeAccount'].created_at)
      const sevenDaysAgo = this.$moment().subtract(7, 'days')
      const startDate = accountCreatedAt.isAfter(sevenDaysAgo) ? accountCreatedAt : sevenDaysAgo
      return startDate.format('YYYY-MM-DD')
    },
    calculateMinDate () {
      return new Date(new this.$moment(this.$store.getters['authentication/activeAccount'].created_at).subtract(1,
        'days'))
    },
    updateDeviceChart (viewColumn) {
      this.displayColumn = viewColumn
      this.deviceChartKey = viewColumn
    },
    clearDeviceChart () { // clear device chart
      this.displayColumn = null
      this.deviceChartKey = 'null'
    },
    async getDeviceAnalytics (filterQuery = {}) {
      this.deviceChartKey = ''
      filterQuery['type'] = 'ads'
      filterQuery['from-date'] = this.filters.dateRange.startDate
      filterQuery['to-date'] = this.filters.dateRange.endDate
      filterQuery['ids'] = this.filters.adset ? this.getAdsetsAdsIds(this.filters.adset) : this.getAdsetsAdsIds(this
        .campaign.adsets)

      const response = await window.axios.post('/analytics/device-chart', filterQuery)
      if (response.data.success) {
        this.deviceChartKey = 'loaded'
        this.deviceChartData = response.data.payload
      }
    },

    // Filters Functions //
    updateActiveFilter ({
      value,
      active
    }) {
      if (active) {
        this.setSelectedFilter(value)
        this.disableAllFiltersExcept(value)
        this.updateMap(value)
        this.updateDeviceChart(value)
      }
    },

    setSelectedFilter (filter) {
      this.selectedFilter = filter
    },


    isFilterSelected (filter) {
      return this.selectedFilter === filter
    },


    disableAllFiltersExcept (filterValue) {
      this.chartFilters.filter(filterItem => filterItem.value !== filterValue).forEach((filterItem) => {
        this.$refs[filterItem.value][0].disable()
      })
    },

    updateMap (filter) {
      this.$refs['map'].updateMap(filter)
    },

    clearMap () {
      this.$refs['map'].clearMap()
    },

    async getMapGeoAnalytics (query = {}) {
      const {
        data
      } = await window.axios.post('/analytics/countries-chart', query)
      if (data.success) {
        this.geoInsights = data.payload
      }

    }
  }
}

</script>

<style lang="scss" scoped>

  .card {
    background: #fff;
    padding: 31px;
    border-radius: 20px;
  }

  .campaign-insights-number::v-deep {
    .device-split {
      border-left: 1px solid #e3e3e3;

      .device-split-desc {
        margin-left: 30px;
      }

      h5 {
        font-weight: 500;
        font-size: 14px;
        color: rgba(44, 44, 44, 0.56);
        margin-bottom: 10px;
      }

      h6 {
        color: #0092d7;
        font-weight: normal;
        font-size: 12px;
        margin-bottom: 30px;
      }
    }

    .device-chart-title {
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      letter-spacing: 0.1px;
      color: "#2c2c2c ";
    }

    .device-chart-desc {
      font-family: Poppins;
      font-style: normal;
      font-weight: normal;
      font-size: 14px !important;
      line-height: 24px;
      color: #0092d7;
    }

    .chart-title {
      margin-bottom: 30px;

      h3 {
        font-weight: 500;
        font-size: 24px;
        color: #2c2c2c;
      }

      span {
        font-weight: normal;
        font-size: 14px;
        color: rgba(44, 44, 44, 0.7);
        position: relative;
        top: 5px;
        margin-left: 20px;
      }
    }

    .vue-treeselect__control {
      height: 40px;
      border: 1px solid #d9d9d9;
    }

    .reportrange-text {
      border: 1px solid #d9d9d9 !important;
    }

    [data-v-26b8cd9e] .vs-icon {
      color: rgba(0, 0, 0, 0.5) !important;
    }

    .speakol-table-filter-button {
      width: 135px;
      background-color: #0092d7 !important;
    }

    .insights-filter-mobile-version {
      display: none;
    }

    .insights-filter-desktop-version {
      display: block;
    }

    .inisghts-cards-background {
      background-color: #fff;
      padding: 20px 20px 20px 20px;
      border: 1px solid #f2f2f2;
      border-radius: 3px;

      .cards-data {
        float: left;

        h3 {
          font-weight: 600;
          font-size: 24px;
          margin-bottom: 5px;
        }

        h4 {
          float: left;
          font-weight: normal;
          font-size: 14px;
          color: rgba(44, 44, 44, 0.7);
        }

        .con-vs-tooltip {
          cursor: pointer;
          float: left;
          margin-left: 5px;

          img {
            width: 16px;
          }
        }
      }

      .cards-icons {
        float: right;
        margin-top: 10px;

        i {
          font-family: 'speakol' !important;
          font-style: normal;
          -webkit-font-smoothing: antialiased;
          padding: 12px;
          border-radius: 100%;
          font-size: 20px;
        }
      }

      .speakol-eye {
        color: rgb(0, 146, 215);
        background-color: rgb(223, 242, 250);
      }

      .speakol-finger-click {
        color: rgb(255, 159, 67);
        background-color: rgb(255, 243, 232);
      }

      .speakol-percentage-sign {
        color: rgb(110, 200, 186);
        background-color: rgb(238, 248, 247);
      }

      .speakol-start {
        color: rgb(219, 40, 40);
        background-color: rgb(251, 229, 229);
      }

      .speakol-user-account {
        color: rgb(170, 213, 117);
        background-color: rgb(245, 250, 238);
      }

      .speakol-us-dollar-spent {
        color: rgb(240, 201, 112);
        background-color: rgb(253, 249, 238);
      }

      .speakol-us-dollar-cpl {
        color: rgb(155, 81, 224);
        background-color: rgb(243, 234, 251);
      }

      .speakol-us-dollar-avg {
        color: rgb(171, 98, 38);
        background-color: rgb(245, 236, 229);
      }
    }
  }

  @media (max-width: 768px) {
    .device-split {
      border-left: none !important;
    }

    .insights-filter-desktop-version {
      display: none !important;
    }

    .insights-filter-mobile-version {
      display: block !important;
    }

    .speakol-table-filter-button-parent {
      width: 100% !important;

      button {
        width: 100% !important;
      }
    }
  }

</style>
